<template>
  <div class="container as-flex flex-vertical main-start cross-center">
    <chart
      v-if="each_config[config_index]&&each_config[config_index].labels&&each_config[config_index].labels.length>0"
      :graph_config="each_config[config_index]"
      :avg="average_config"
      :indicator="indicator"
      :offset="offsetMapping[offset]||'--'"
      class="indicator-swiper-item"
    ></chart>
    <div
      v-else
      class="as-full-height as-full-width as-flex main-center cross-center fc-gray-2"
    >尚未到监测期，暂无数据</div>
  </div>
</template>

<script>
const offsetMapping = {
  /////kKkkdmfmgfmcv,cv,cmvmvdofsdjvdvXAZXDFRYJMIOL0P;LL
  "1.0": "映后一周",
  "0.0": "上映当周",
  "-1.0": "映前一周",
  "-2.0": "映前两周",
  "-3.0": "映前三周",
  "-4.0": "映前四周"
};
const indicatorMapping = {
  awareness: "认知",
  primary: "首选"
};
import { clone } from "lodash";
import chart from "./chart";
import config_process from "../../mixin/index/chart_config_process.js";
export default {
  props: {
    indicator: {},
    offset: {},
    config: {},
    update_date: {}
  },
  components: {
    chart: chart
  },
  mixins: [config_process],
  data() {
    return {
      each_config: [],
      average_config: null,
      offsetMapping: offsetMapping,
      indicatorMapping: indicatorMapping,
      // indicator: "primary",
      questionTip: false
    };
  },
  computed: {
    config_index() {
      return this.indicator === "primary" ? 0 : 1;
    }
  },
  methods: {
    pageClick() {
      this.questionTip = false;
    },
    showQuestionTip(event) {
      // this.$Tip({ event: event, message: "哈哈哈" });
      this.questionTip = true;
    }
  },
  created() {},
  watch: {
    config: {
      handler: function(to, from) {
        this.processConfig(to.results);
        this.average_config = to.avg;
      },
      deep: true
    }
  }
};
</script>


<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 0;
}

// .question-tip {
//   height: 100%;
//   margin-left: 0.05rem;
//   position: relative;
// }
// .question-tip-icon {
//   // width: 100%;
//   // height: 100%;
// }
// .question-tip-container {
//   position: absolute;
//   z-index: 1;
//   top: 0.3rem;
//   left: 0.125rem;
//   transform: translateX(-50%);
//   background-color: rgba(0, 0, 0, 0.8);
//   width: 3rem;
//   height: 0.6rem;
//   border-radius: 0.05rem;
//   color: white;
// }
</style>
